import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { IMG } from "../../../assets";
import { TESTIMONIALS } from "../../../api/Testimonials";
import { CONSTANT } from "../../../constant/Constant";

export default function Feedback({ image }) {
  const [data, setData] = useState([]);

  const getDataList = async () => {
    try {
      const res = await TESTIMONIALS.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch cake information");
      }
      const array = [];
      res.data.map((itm) => {
        if (itm.isApproved) {
          array.push(itm);
        }
        return array;
      });
      setData(array);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };

  useEffect(() => {
    getDataList();
  }, []);

  return (
    <div className="w-full h-auto flex relative bg-gray">
      <div className="w-[20%] h-full absolute z-1 bg-white hidden lg:block"></div>
      <div className="w-full h-full relative z-1 flex justify-center items-center">
        <div className="w-5/6 max-w-screen-2xl py-15">
          <div className="">
            <p className="font-satoshi  text-4xl font-bold">
              What Our Clients Are Saying
            </p>
          </div>
          <div className="flex justify-between mt-15">
            <div className="w-[30%] hidden lg:block">
              <div className="h-4/5 w-full flex justify-end relative ">
                <div className="bg-event absolute h-20 w-20 flex justify-center items-center rounded-full -mt-9 ml-6">
                  <img className="w-10 h-10" src={IMG.quote} alt="" />
                </div>

                <div className=" h-[300px] w-full shadow-2xl overflow-hidden ">
                  <img
                    className="object-cover w-full h-[300px]"
                    src={`${CONSTANT.UI_URL}image/${image}`}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="w-[100%] lg:w-[70%] ">
              <div className="h-auto w-full">
                {data.length > 0 && (
                  <Swiper
                    spaceBetween={53}
                    slidesPerView={1}
                    breakpoints={{
                      1000: {
                        slidesPerView: 1,
                      },
                      1200: {
                        slidesPerView: 2,
                      },
                    }}
                    autoplay={{
                      delay: 5000,
                    }}
                    // onSlideChange={() => console.log("slide change")}
                    // onSwiper={(swiper) => console.log(swiper)}
                    modules={[Autoplay]}
                  >
                    {data.map((data) => (
                      <SwiperSlide key={data.id}>
                        <div className="h-full w-6/7 mx-10 flex flex-col justify-between">
                          <div className="">
                            <div className="">
                              <p className="text-4xl font-bold lg:text-3xl font-mono">
                                {data.title}
                              </p>
                            </div>
                            <div className="h-auto my-10 ">
                              <p className="text-xl w-full text-body lg:text-lg">
                                "{data.message}"
                              </p>
                            </div>
                          </div>
                          <div className="">
                            <div className="h-auto">
                              <p className="text-2xl font-mono">{data.name}</p>
                            </div>
                            <div className="h-6 text-body font-mono">
                              {data.location}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
